
import { cookieSet } from '@/common/cookie';

export default {
  data() {
    return {};
  },
  computed: {},
  created() {
    this.saveToken();
  },
  mounted() {
  },
  methods: {
    saveToken() {
      // 处理从小程序入口跳转过来
      if (this.$route.query.token) {
        let token = this.$route.query.token || '';
        token = (token).replace(/\s/g, '+');
        if (
          document.domain.indexOf('vas') > -1 ||
          document.domain.indexOf('zengzhi') > -1 ||
          document.domain.indexOf('localhost') > -1
        ) {
          cookieSet('token', token || '');
        }
      }
      if (this.$route.query.nav) {
        localStorage.setItem('_nav', this.$route.query.nav);
      }
      if (this.$route.query.phone) {
        localStorage.setItem('_phone', this.$route.query.phone);
      }
      if (this.init) {
        this.init();
      }
    }
  }
};
